import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import axios from 'axios';
import useStyles from './styles';
import { CUSTOMER_FUEL_REQUEST_RECEIPT } from '../../constants/api';
import Loading from '../../components/loading';
import RightContent from './right_content';
import LeftContent from './left_content';

function Receipt() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    vRequestCode: '',
    vOperatorName: '',
    vLocationImage: '',
    vFuelInfoTitle: '',
    jalaliDateTime: '',
    iVolumeReceived: '',
    price: {
      iDiscount: 0,
      iBasePrice: 0,
      iServicePrice: 0,
      iTotalPrice: 0,
    },
  });
  let { token } = useParams();
  token = token.replace('token=', '');

  useEffect(() => {
    setLoading(true);
    getReceiptData();
  }, []);

  const getReceiptData = async () => {
    try {
      let url = process.env.REACT_APP_API_URL + CUSTOMER_FUEL_REQUEST_RECEIPT;
      let response = await axios.post(url, { vToken: token });
      let data = response.data;
      if (data.settings.success === 1) {
        setData(data.data[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Grid style={{ margin: 10 }}>
        <Grid container>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Grid className={classes.root}>
              <Grid container spacing={2}>
                {loading ? (
                  <Loading loadingPage={loading} />
                ) : (
                  <>
                    <Grid item xs={12} md={4}>
                      <RightContent {...data} />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <LeftContent {...data} />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Receipt;
